import {
  ShipmentsIcon,
  EmployeeIcon,
  PackageIcon,
  CarrierConfigIcon,
  StockManagementIcon,
  PickSheetIcon,
} from "../components/Icon";
import { LeftNavItemInterface } from "../interfaces";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { LOCALSTORAGE_ORDERS_SHIPMENTS_KEY, LOCALSTORAGE_SHIPMENTS_KEY } from "./common";

export const SUPER_ACCESS_ROLE = ["ADMIN"];
export const RESTRICTED_PAGE_KEYS = ["admin", "carriers"];
export const DISABLED_PAGES = [];
export const DISABLED_ICON_TOOLTIP_MESSAGE = "To be released soon";

export const leftNavItems: LeftNavItemInterface[] = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    active: true,
    key: "dashboard",
    redirectTo: "/dashboard",
  },
  {
    title: "Orders",
    icon: <PackageIcon />,
    active: false,
    key: "orders",
    redirectTo: "/orders",
    hotKey: true,
    submenu: [
      { title: "Unpicked", tabId: "UN_PICKED" },
      { title: "Assigned", tabId: "ASSIGNED" },
      { title: "Error", tabId: "ERROR" },
      { title: "Issue", tabId: "ISSUES" },
      { title: "OnHold", tabId: "ON_HOLD" },
      { title: "Cancelled", tabId: "CANCELLED" },
    ],
    localStorageSetSubMenu: LOCALSTORAGE_ORDERS_SHIPMENTS_KEY,
  },
  {
    title: "Shipments",
    icon: <ShipmentsIcon />,
    active: false,
    key: "shipments",
    redirectTo: "/shipments",
    hotKey: true,
    submenu: [
      { title: "All Picked Orders", tabId: "ALL_PICKED_ORDERS" },
      { title: "Click and Collect", tabId: "CLICK_AND_COLLECT" },
      { title: "Error", tabId: "ERROR" },
      { title: "Pick and Pack ", tabId: "PICK_AND_PACK" },
      { title: "Shipped ", tabId: "SHIPPED" },
      { title: "All Orders", tabId: "ALL_ORDERS" },
      { title: "PrintHub ", tabId: "PRINT_HUB" },
    ],
    localStorageSetSubMenu: LOCALSTORAGE_SHIPMENTS_KEY,
  },
  {
    title: "Admin Management",
    icon: <EmployeeIcon />,
    active: false,
    key: "admin",
    redirectTo: "/admin",
  },
  {
    title: "Carriers",
    icon: <CarrierConfigIcon />,
    active: false,
    key: "carriers",
    redirectTo: "/carriers",
  },
  {
    title: "Stock Management",
    icon: <StockManagementIcon />,
    active: false,
    key: "stock-management",
    redirectTo: "/stock-management",
  },
  {
    title: "Pick Sheet",
    icon: <PickSheetIcon />,
    active: false,
    key: "pick-sheet",
    redirectTo: "/picksheet",
  },
];
